module.exports = __webpack_public_path__ + "img/bill_active.9315a0bd.svg";